import type { FlotiqHorecaApiItem, FlotiqStore } from "@jti/fe-common";

const transformHorecaMarker = (marker: FlotiqHorecaApiItem): FlotiqStore => {
  const { Street, City, ZipCode, State, Country, HorecaName, HorecaId, ...rest } = marker.item;
  const address = [Street, City, ZipCode, State, Country].filter(Boolean).join(", ");

  return {
    ...rest,
    Street,
    City,
    ZipCode,
    State,
    Country,
    StoreName: HorecaName,
    ExternalId: HorecaId,
    address,
  };
};

export const getTransformedHorecaMarkers = (items: FlotiqHorecaApiItem[]): FlotiqStore[] =>
  items.filter((marker) => marker.item.Status !== false).map(transformHorecaMarker);
